module.exports = __webpack_public_path__ + "img/homeicon.9c2d7e45.svg";